import { autofill } from 'redux-form'

const markDeleted = (form, arrayName, index, v) => {
  const field = `${arrayName}[${index}].isDeleted`
  // Need to actually delete from redux
  return autofill(form, field, v)
}

export default markDeleted



// WEBPACK FOOTER //
// ./src/modules/Forms/utils/markDeleted.js